import { useContext } from 'react';
import { AuthContext, type AuthState } from './AuthProvider';

/**
 * Returns the unified auth state. Works in both fake-mode (mock claims) and
 * real-Cognito mode — the AuthProvider does the underlying mapping.
 */
export function useAuth(): AuthState {
  return useContext(AuthContext);
}
